import React from 'react';
import { connect } from 'react-redux';
import store from '../store';
import PropTypes from 'prop-types';
import withRouter from './WithRouter';
import classnames from 'classnames';
import { addClient, listClients } from '../actions/client';
import { Button, IconButton, Input, InputGroup, Toggle } from 'rsuite';
import EyeIcon from '@rsuite/icons/legacy/Eye';
import EyeSlashIcon from '@rsuite/icons/legacy/EyeSlash';
import PlusIcon from '@rsuite/icons/Plus';

class ClientAdd extends React.Component {
  constructor() {
      super();
      this.state = {
        companySwitch: false,
        name: '',
        modal: false,
        organizations: [],
        errors: {},
      };
      this.handleInputChange = this.handleInputChange.bind(this);
      this.handleToggleChange = this.handleToggleChange.bind(this);
      this.handleSubmit = this.handleSubmit.bind(this);
      this.showModal = this.showModal.bind(this);
      this.hideModal = this.hideModal.bind(this);
  }

  showModal(event) {
    this.setState({modal: true});
  };
  hideModal(event) {
    this.setState({modal: false});
  };

  handleInputChange(n, v ) {
      this.setState({
          [n]: v
      })
  }
  handleToggleChange(v) {
    console.log('handleToggleChange', v);
    this.setState({companySwitch: v});
  }

  handleSubmit(e) {
      e.preventDefault();
      let currentorg = localStorage.getItem('currentorg');
      const client = {
          name: this.state.name,
          organization: currentorg,
          errors: {}
      }
      this.props.addClient(client, this.props.history);
      this.props.listClients( currentorg, 'name', this.props.history);
      this.setState({modal: false});
  }

    render() {
      const { errors } = this.state;

        return (
        <div>
          <div className="button-container" onClick={this.showModal}>
            <IconButton
              appearance="primary"
              className="iron-button add"
              icon={<PlusIcon />}
              >Dodaj klienta</IconButton>
          </div>
          <div className={`modal-over add ${this.state.modal === true? 'opened': ''}`}>
            <div className="modal">
              <div className="modal-header">
              <div className="title">
              Dodaj klienta
              </div>
              <div className="close-button">
                <button onClick={this.hideModal} id="modal-btn-close" className="on"><span></span><span></span><span></span>
                </button>
              </div>
              </div>
              <form onSubmit={ this.handleSubmit }>
                <div className="form-group">
                    <Input
                    type="text"
                    placeholder="Name"
                    autoComplete="name"
                    className={classnames('form-control form-control-lg', {
                        'is-invalid': errors.name
                    })}
                    name="name"
                    onChange={value => {
                      this.handleInputChange('name', value);
                    }}
                    value={ this.state.name }
                    />
                    <Toggle 
                      className="company-switch"
                      onChange={this.handleToggleChange}
                      checked={this.state.companySwitch}
                    />

                  { this.state.companySwitch &&
                      <div> other data</div>
                  }

                    {errors.name && (<div className="invalid-feedback">{errors.name}</div>)}
                </div>
                <div className="form-group">
                    <IconButton
                      appearance="primary"
                      type="submit"
                      className="iron-button"
                      icon={<PlusIcon />}

                      >
                        Dodaj klienta
                    </IconButton>
                </div>
              </form>
            </div>
          </div>
        </div>
        );
    }
}

ClientAdd.propTypes = {
    addClient: PropTypes.func.isRequired,
    listClients: PropTypes.func.isRequired
};


const mapStateToProps = state => ({
  orgcurrent: state.orgcurrent,
  errors: state.errors
});

export default connect(mapStateToProps,{ addClient, listClients })(withRouter(ClientAdd))
